import Vue from 'vue';

Vue.component('fuel-transaction-index', () =>
    import(/* webpackChunkName: 'fuel-transaction-index' */ './fuel-transaction-index.vue'),
);
